import React from 'react';
import { Link } from 'react-router-dom';
import './styles/ReportPage.css';
import arrowR from '/assets/ArrowR.svg';

const reportItems = [
  { path: "/report/showweather", label: "สภาพอากาศ SmartPole" },
  { path: "/report/showwater", label: "รายงานสถานะระดับน้ำรายชั่วโมง" },
  { path: "/report/showwaterlevel", label: "รายงานสถานะระดับน้ำ 24 ชั่วโมง" },
];

const smartPoleItems = [
  { path: "/report/showpoleenergy", label: "รายงานสถานะการใช้พลังงานเสา" },
  { path: "/report/showpoleenergy24", label: "รายงานสถานะการใช้พลังงานเสา 24 ชั่วโมง" },
  { path: "/report/showdetailedreport", label: "รายงานรายละเอียดของแต่ละเสา (ติดตั้งกล้อง จอ การปรับไฟ)" },
];

const userBranchItems = [
  { path: "/report/showuserreport", label: "รายงานผู้ใช้งานในระบบ SmartPole" },
  { path: "/report/showbranches", label: "สาขาทั้งหมดในระบบ SmartPole" },
  { path: "/report/showbranchdetail", label: "รายละเอียดของแต่ละสาขา" },
];

const handleRippleEffect = (event) => {
  const button = event.currentTarget;
  const ripple = document.createElement('span');
  const diameter = Math.max(button.clientWidth, button.clientHeight);
  const radius = diameter / 2;

  ripple.style.width = ripple.style.height = `${diameter}px`;
  ripple.style.left = `${event.clientX - button.getBoundingClientRect().left - radius}px`;
  ripple.style.top = `${event.clientY - button.getBoundingClientRect().top - radius}px`;
  ripple.classList.add('ripple');

  const rippleContainer = button.querySelector('.ripple-container');
  rippleContainer.appendChild(ripple);

  ripple.addEventListener('animationend', () => {
    ripple.remove();
  });
};

const Report = () => (
  <div className="container-report">
    <div className="container-report-main">
      <h1>รายงาน</h1>
      <h2>รายงานสภาพ</h2>
      <ul>
        {reportItems.map(({ path, label }) => (
          <Link key={path} to={path}>
            <li onClick={handleRippleEffect}>
              {label} <img src={arrowR} alt="arrow" />
              <span className="ripple-container" style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, overflow: 'hidden' }}></span>
            </li>
          </Link>
        ))}
      </ul>
      <h2>รายงาน SmartPole</h2>
      <ul>
        {smartPoleItems.map(({ path, label }) => (
          <Link key={path} to={path}>
            <li onClick={handleRippleEffect}>
              {label} <img src={arrowR} alt="arrow" />
              <span className="ripple-container" style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, overflow: 'hidden' }}></span>
            </li>
          </Link>
        ))}
      </ul>
      <h2>รายงานผู้ใช้งาน และข้อมูลสาขา</h2>
      <ul>
        {userBranchItems.map(({ path, label }) => (
          <Link key={path} to={path}>
            <li onClick={handleRippleEffect}>
              {label} <img src={arrowR} alt="arrow" />
              <span className="ripple-container" style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, overflow: 'hidden' }}></span>
            </li>
          </Link>
        ))}
      </ul>
    </div>
  </div>
);

export default Report;
